import { componentSizeMap } from '@code-monkey-ui/constants'

import type { ComponentSize } from '@code-monkey-ui/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
